import React from 'react'
import { MerchantContext, SetupMerchant } from './index'

export const GlobalContext = ({ children }: { children?: React.ReactNode }) => {
  return (
    <MerchantContext.Provider value={SetupMerchant()}>
      {children}
    </MerchantContext.Provider>
  )
}

export default GlobalContext
